module.exports = __webpack_public_path__ + "img/img5.019b961e.svg";